import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {LabelWithContent} from '../typography/label-with-content';

import {RecentSubmissions} from './recent-submissions';

type Props = {
    fieldType: string;
    inputName: string;
    exampleValues: string;
    displayExampleValuesVertically?: boolean;
};

export function MappingCardData(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <StackLegacy spacing={16} isHorizontal={true}>
                <LabelWithContent label='Field type' content={props.fieldType} />
                <LabelWithContent label='Input name' content={props.inputName} />
            </StackLegacy>
            <RecentSubmissions
                displayVertically={props.displayExampleValuesVertically}
                exampleValues={props.exampleValues}
            />
        </StackLegacy>
    );
}
